import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button
} from '@mui/material';

const ConfirmationModal = ({
  open,
  onClose,
  title,
  content,
  confirmText = 'Yes',
  cancelText = 'No',
  onConfirm,
  width = 500,
  cancelButtonProps = {}
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: width,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          outline: "none",
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="subtitle1"
          component="h2"
        >
          {title}
        </Typography>
        
        {content && (
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {content}
          </Typography>
        )}

        <Grid container mt={2} spacing={2}>
          <Grid item xs={6}>
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={onClose}
              {...cancelButtonProps}
            >
              {cancelText}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              fullWidth
              onClick={onConfirm}
              sx={{ backgroundColor: '#0B62A1' }}
            >
              {confirmText}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;